import { render, staticRenderFns } from "./RicMessages.vue?vue&type=template&id=21191f32"
import script from "./RicMessages.vue?vue&type=script&lang=ts"
export * from "./RicMessages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports